export default function queryString(search) {
  const paramsString = search.replace(/^\?/, ''); // Remove leading '?' if present
  const params = new URLSearchParams(paramsString);
  const queryParams = {};

  params.forEach((value, key) => {
    queryParams[key] = value;
  });

  return queryParams;
}
